<div class="flex flex-col gap-1 relative text-view">
    <label [style.visibility]="showLabel? 'visible': 'hidden'" [for]="label" class="poppins-regular text-slate-500">{{label}}</label>
    <div class="value text-[18px] text-slate-600" [ngClass]="{'text-primary': isPrimary, 'poppins-medium': isBold}">{{value || '-'}}</div>
</div>
